import { Component } from '@angular/core';
import { CMSService } from '../Services/cms.service';
import { HttpEventType, HttpClient } from '@angular/common/http';
import { CmsAboutUsLandingProperties } from '../Models/CmsAboutUsProperties';
import * as $ from 'jquery';
import { Canvg } from 'canvg';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cms-aboutuslanding',
  templateUrl: './cms-aboutuslanding.component.html',
  styleUrls: ['./cms-aboutuslanding.component.css']
})
export class CmsAboutUsLandingComponent {
  fSocialObj = new CmsAboutUsLandingProperties();
  ValidateFileFormat: boolean = false;
  constructor(private router: Router,private userService: CMSService, public cmsService: CMSService, private http: HttpClient) { }

  public progress: number;
  public message: string;
  public backImagePath: any;
  public landingImagePath: any;
  public responseMessage: string;
  ssvgurl: string;
  UpdateFileImage: string = "";
  createFileImage: any;
  uploadedstatus: boolean = false;
  //public uploadFile = (files) => {
  //  if (files.length === 0) {
  //    return;
  //  }
  //  let fileToUpload = <File>files[0];
  //  const formData = new FormData();
  //  formData.append('file', fileToUpload, fileToUpload.name);
  //  this.http.post('https://localhost:44339/api/CmsAboutUs/SaveAboutUsLandingBG', formData, { reportProgress: true, observe: 'events' })
  //    .subscribe(event => {
  //      if (event.type === HttpEventType.UploadProgress)
  //        this.progress = Math.round(100 * event.loaded / event.total);
  //      else if (event.type === HttpEventType.Response) {
  //        this.backImagePath = event.body;
  //        this.message = 'Uploaded Successfully...';
  //        //this.onUploadFinished.emit(event.body);
  //      }
  //    });
  //}

  //public uploadLanding = (files) => {
  //  if (files.length === 0) {
  //    return;
  //  }
  //  let fileToUpload = <File>files[0];
  //  const formData = new FormData();
  //  formData.append('file', fileToUpload, fileToUpload.name);
  //  this.http.post('https://localhost:44339/api/CmsAboutUs/SaveAboutUsLandingImages', formData, { reportProgress: true, observe: 'events' })
  //    .subscribe(event => {
  //      if (event.type === HttpEventType.UploadProgress)
  //        this.progress = Math.round(100 * event.loaded / event.total);
  //      else if (event.type === HttpEventType.Response) {
  //        this.landingImagePath = event.body;
  //        this.message = 'Uploaded Successfully...';
  //        //this.onUploadFinished.emit(event.body);
  //      }
  //    });
  //}


  ngOnInit() {
    this.LoadEditableData();
  }
  LoadEditableData() {
    try {
      if (localStorage.getItem("aboutUsID") != undefined || localStorage.getItem("aboutUsID") != null) {
        let id = Number(localStorage.getItem("aboutUsID"));
        if (id != 0 || id != undefined) {
          document.querySelector(".updatemain").classList.remove('update_section');
          this.userService.getAboutUsLandingById(id).subscribe((data) => {
            this.fSocialObj = data[0] as CmsAboutUsLandingProperties;
            localStorage.removeItem("aboutUsID");
            this.ssvgurl = this.fSocialObj.landingImage;
          });
        }
        else {
          document.querySelector(".createmain").classList.remove('create_section');
        }
      }
      else {
        document.querySelector(".createmain").classList.remove('create_section');
      }
    }
    catch (e) {
      //////console.log (e);
    }
  }
  createAbousUs() {
    var formData = new FormData();
    formData.append("imagename", this.createFileImage);
    formData.append("mainTitle", this.fSocialObj.mainTitle);
    formData.append("landingTitle", this.fSocialObj.landingTitle);
    formData.append("landingDetails", this.fSocialObj.landingDetails);
   
    formData.append(this.UpdateFileImage, this.fSocialObj.landingImage)
    this.userService.createAboutUsLanding(formData).subscribe((data) => {
      if (data == true) {
        this.router.navigateByUrl('/cms');

      }
      else {

        $("#response-screen").show();
        document.getElementById("response-screen").innerHTML = "Error occured while inserting data :("
        $("#response-screen").delay(5000).hide(1000);
      }
    });
  }
 
  onSubmit() {
   
    if (this.fSocialObj.landingImage.length === 0) {
      return;
    }
    this.createAbousUs();
 
      //this.fSocialObj.landingImage = this.landingImagePath;
   
      //this.userService.createAboutUsLanding(this.fSocialObj).subscribe((data => {
      //  if (data === true) {
      //    $("#response-screen").show();
      //    document.getElementById("response-screen").innerHTML = "Data inserted Successfully :)"
      //    $("#response-screen").delay(5000).hide(1000);
      //  }
      //  else {
      //    $("#response-screen").show();
      //    document.getElementById("response-screen").innerHTML = "Error occured while inserting data :("
      //    $("#response-screen").delay(5000).hide(1000);
      //  }
      //}));
    // else {
    //  this.fSocialObj.backgroundImage = this.backImagePath;
    //  this.fSocialObj.landingImage = this.landingImagePath;
    //  this.userService.updateAboutUsLanding(this.fSocialObj).subscribe((data => {
    //    if (data === true) {
    //      $("#response-screen").show();
    //      document.getElementById("response-screen").innerHTML = "Data updated Successfully :)"
    //      $("#response-screen").delay(5000).hide(1000);
    //    }
    //    else {
    //      $("#response-screen").show();
    //      document.getElementById("response-screen").innerHTML = "Error occured while updating data :("
    //      $("#response-screen").delay(5000).hide(1000);
    //    }
    //  }));
    //}

    ////////console.log (this.imagePath);
  }
  cancel() {
    this.router.navigateByUrl('/cms');
  }
  validateFileType(fileName): boolean {

    var idxDot = fileName.lastIndexOf(".") + 1;
    var extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
    if (extFile == "svg" || extFile == "png" || extFile == "jpg" || extFile == "jpeg") {
      //TO DO
      this.ValidateFileFormat = true;
    } else {
      this.ValidateFileFormat = false;
    }
    return this.ValidateFileFormat;
  }
  onFileChangedCreate(event) {
    this.ssvgurl = "";
    const filess = event.target.files;

    this.createFileImage = event.target.files[0].name;
    this.fSocialObj.landingImage = event.target.files[0];
    if (filess.length === 0) {
      return;
    }
    const filename = event.target.files[0].name;
    const mimeType = filess[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = "Only images are supported.";
      return;
    }

    if (this.validateFileType(filename) == true) {
      var idxDot = filename.lastIndexOf(".") + 1;
      var extFile = filename.substr(idxDot, filename.length).toLowerCase();
      if (extFile == "svg") {
        const reader = new FileReader();
        this.landingImagePath = filess;
        reader.readAsDataURL(filess[0]);
        let imageurl = document.getElementById("svg") as HTMLImageElement;

        reader.onload = async (_event) => {

          imageurl.src = (reader.result).toString();
          const canvass = document.createElement('canvas');
          canvass.id = "newcanvas";
          canvass.width = 250;
          canvass.height = 250;
          const ctx = canvass.getContext('2d');
          /* ctx.clearRect(0, 0, canvass.width, canvass.height);*/
          const v = await Canvg.from(ctx, imageurl.src);

          v.start();
          var processedimage = canvass.toDataURL("img/png");
          //var s = new XMLSerializer().serializeToString(imageurl.src);
          //var encodedData = window.btoa(s);
          //this.ssvgurl = encodedData;
          this.ssvgurl = "";
          this.ssvgurl = processedimage;




        }

      }
      else {


        const reader = new FileReader();
        this.landingImagePath = filess;
        reader.readAsDataURL(filess[0]);
        reader.onload = (_event) => {
          this.ssvgurl = (reader.result).toString();

        }
      }


    }
    else {

      document.getElementById("messageLogo1").innerHTML = "Only .svg & .png Formats Are Allowed";
      this.ssvgurl = "";
      setTimeout(() => { document.getElementById("messageLogo1").innerHTML = ""; }, 5000);
      return;
    }

  }



  //update data

  onFileclick(event) {
    this.ssvgurl = "";
    const files = event.target.files;
    this.UpdateFileImage = event.target.files[0].name;
    this.fSocialObj.landingImage = event.target.files[0];
    if (files.length === 0) {
      return;
    }
    const filename = event.target.files[0].name;
    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = "Only images are supported.";
      return;
    }

    if (this.validateFileType(filename) == true) {
      var idxDot = filename.lastIndexOf(".") + 1;
      var extFile = filename.substr(idxDot, filename.length).toLowerCase();
      if (extFile == "svg") {
        const reader = new FileReader();
        this.landingImagePath = files;
        reader.readAsDataURL(files[0]);
        let imageurl = document.getElementById("svg") as HTMLImageElement;
        imageurl.style.display = "none";
        reader.onload = async (_event) => {

          imageurl.src = (reader.result).toString();
          const canvass = document.createElement('canvas');
          canvass.id = "newcanvas";
          canvass.width = 250;
          canvass.height = 250;
          const ctx = canvass.getContext('2d');
          /* ctx.clearRect(0, 0, canvass.width, canvass.height);*/
          const v = await Canvg.from(ctx, imageurl.src);

          v.start();
          var processedimage = canvass.toDataURL("img/png");
          //var s = new XMLSerializer().serializeToString(imageurl.src);
          //var encodedData = window.btoa(s);
          //this.ssvgurl = encodedData;
          this.ssvgurl = "";
          this.ssvgurl = processedimage;




        }

      }
      else {

        this.ssvgurl = "";
        const reader = new FileReader();
        this.landingImagePath = files;
        reader.readAsDataURL(files[0]);
        reader.onload = (_event) => {
          this.ssvgurl = (reader.result).toString();

        }
      }


    }
    else {

      document.getElementById("messageLogo1").innerHTML = "Only .svg & .png Formats Are Allowed";
      this.ssvgurl = "";
      setTimeout(() => { document.getElementById("messageLogo1").innerHTML = ""; }, 5000);
      return;
    }

  }


  UpdateSocial() {

    this.UpdateAboutUs();
  }
 
  UpdateAboutUs() {
    var formData = new FormData();
    formData.append("sr", (this.fSocialObj.aboutUsID).toString());
    formData.append("imagename", this.UpdateFileImage);
    formData.append("mainTitle", this.fSocialObj.mainTitle);
    formData.append("landingTitle", this.fSocialObj.landingTitle);
    formData.append("landingDetails", this.fSocialObj.landingDetails);
    formData.append("landingImageName", this.fSocialObj.landingImageName);
    formData.append(this.UpdateFileImage, this.fSocialObj.landingImage);
    this.userService.updateAboutUsLanding(formData).subscribe((data) => {
      if (data == true) {
        this.router.navigateByUrl('/cms');

      }
      else {

        $("#response-screen").show();
        document.getElementById("response-screen").innerHTML = "Error occured while inserting data :("
        $("#response-screen").delay(5000).hide(1000);
      }
    });
  }

}
